export default "__VITE_ASSET__CTxaorgY__"